<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<div id="background"></div>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-sgzp-master-login></app-sgzp-master-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-sgzp-master-register></app-sgzp-master-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-sgzp-master-forgot-password></app-sgzp-master-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-sgzp-master-change-password-sent></app-sgzp-master-change-password-sent>
  </div>

  <app-sgzp-master-register-resend
    *ngIf="page === 'register-resend'"
  ></app-sgzp-master-register-resend>
</ng-container>
